import { call } from 'api/base';

export const MerchantsAPI = {
	current(token) {
		return call('merchants/current', 'GET', token);
	},
}